import { AxiosInstance } from "axios";
import React, { lazy, Suspense } from "react";
import LoadingScreen from "src/components/LoadingScreen";
import envManager from "src/utils/EnvManager";
import { getCookie } from "src/utils/utils";
import { authenMock } from "./authenMock";
import { settMock } from "./sttMock";

export const AxiosMock: React.FC = ({ children }) => {
  const isMock = getCookie("useMock");

  if (isMock === "true") {
    const MockContent = lazy(() => import("./mock"));
    return (
      <Suspense fallback={<LoadingScreen />}>
        <MockContent>{children}</MockContent>;
      </Suspense>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AxiosMock;
